import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus--sprite",
  "use": "plus--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus--sprite\">\n    <path d=\"M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol